import CryptoJS from 'crypto-js';

export default function MD5(message: any): string {
  if (!message) return '';
  return CryptoJS.MD5(String(message)).toString(CryptoJS.enc.Base64);
}
